import { get } from '@services/borderService';
import borderActions from '@constans/store/border/borderActions';
import borderMutations from '@constans/store/border/borderMutations';
const actions = {
    [borderActions.GET_BORDERS]: async ({ commit }, payload) => {
        return await get(payload).then((response) => {
            if (response.status === 'Success') {
                commit(borderMutations.SET_BORDERS, response.data);
                return response.data;
            }
            return null;
        });
    }
};
export default actions;
